export { default } from './StatusText';
